<template>
  <div class="main-stations__type3">
    <div class="main-stations__title"><span>Линии</span></div>
    <div v-if="station.linesVoltage !== null" class="main-stations__lines">
      <i @click.stop="openSatec(line.satecId)" v-bind:key="line.satecId" v-for="line in station.linesVoltage" v-bind:class="line.voltage > 0 ? 'line-status' : 'line-status red'">
        <b class="status">{{ line.voltage > 0 ? 'on' : 'off' }}</b>
        <b class="kwh">{{ round(line.voltage) }} V</b>
      </i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Lines',
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  methods: {
    openSatec (id) {
      this.$router.push({
        name: 'device-view',
        params: { id: id }
      })
    },
    round (val) {
      return Math.round(val)
    }
  }
}
</script>
